var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { Observable } from 'rxjs';
var SharedCaseComponent = /** @class */ (function () {
    function SharedCaseComponent(router, apiService, util) {
        this.router = router;
        this.apiService = apiService;
        this.util = util;
        this.caseID = "";
        this.caseTicket = "";
        this.sharedHigh = 0;
        this.sharedMedium = 0;
        this.sharedLow = 0;
        this.allHigh = 0;
        this.allMedium = 0;
        this.allLow = 0;
        this.sharedCaseList = [];
        this.allCaseList = [];
        this.caseSubTypeSharedList = [];
        this.caseSubTypeAllList = [];
        this.caseSubTypeDetailSharedList = [];
        this.caseSubTypeDetailAllList = [];
        this.caseNoShared = "";
        this.firstnameShared = "";
        this.lastnameShared = "";
        this.telephoneShared = "";
        this.caseTypeShared = "";
        this.caseSubTypeShared = "";
        this.subTypeDetailShared = "";
        this.statusShared = "";
        this.caseTypeMy = "";
        this.caseSubTypeMy = "";
        this.subTypeDetailMy = "";
        this.statusMy = "";
        this.caseNoAll = "";
        this.firstnameAll = "";
        this.lastnameAll = "";
        this.telephoneAll = "";
        this.caseTypeAll = "";
        this.caseSubTypeAll = "";
        this.subTypeDetailAll = "";
        this.statusAll = "";
        this.dtSharedCase = null;
        this.dtAllCase = null;
        this.role = {};
    }
    SharedCaseComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                thisTs = this;
                this.util.ShowWaiting(true);
                this.util.InitValidation();
                this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                this.role = JSON.parse(this.cookieData.role);
                //this.role = JSON.parse(localStorage.getItem("role"))
                //await this.callApi()
                this.callApi();
                $('#dateFromShared').on('changeDate', function (ev) {
                    $('#dateToShared').datepicker('setStartDate', ev.date);
                });
                $('#dateToShared').on('changeDate', function (ev) {
                    $('#dateFromShared').datepicker('setEndDate', ev.date);
                });
                $('#dateFromAll').on('changeDate', function (ev) {
                    $('#dateToAll').datepicker('setStartDate', ev.date);
                });
                $('#dateToAll').on('changeDate', function (ev) {
                    $('#dateFromAll').datepicker('setEndDate', ev.date);
                });
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    SharedCaseComponent.prototype.callApi = function () {
        var _this = this;
        var tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
        var allPara = "";
        if (this.role.dpa_list_allcase) {
            allPara = "case_date_from=" + tmpDate;
        }
        Observable.forkJoin(this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("crmservice", "caseIncident", allPara)).subscribe(function (data) {
            _this.caseStatusList = data[0];
            _this.caseTypeList = data[1];
            _this.subTypeTmpList = data[2];
            _this.subTypeDetailTmpList = data[3];
            _this.allCaseList = data[4];
            _this.BindCase();
            _this.util.ShowWaiting(false);
        }, function (err) {
            console.error(err);
            _this.util.ShowWaiting(false);
        });
    };
    SharedCaseComponent.prototype.BindCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var i, order, orderpri;
            return __generator(this, function (_a) {
                this.allHigh = this.allMedium = this.allLow = 0;
                this.allCaseList.forEach(function (c) {
                    if (c.dpa_caseseverityidname != null) {
                        if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                            _this.allHigh++;
                        }
                        else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                            _this.allMedium++;
                        }
                        else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                            _this.allLow++;
                        }
                    }
                });
                for (i = 0; i < this.allCaseList.length; i++) {
                    order = void 0;
                    orderpri = void 0;
                    if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress") {
                        order = 1;
                    }
                    else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold") {
                        order = 2;
                    }
                    else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new") {
                        order = 3;
                    }
                    else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved") {
                        order = 4;
                    }
                    else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel") {
                        order = 5;
                    }
                    else {
                        order = 6;
                    }
                    if (this.allCaseList[i].dpa_caseseverityidname != null) {
                        if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                            orderpri = 1;
                        }
                        else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                            orderpri = 2;
                        }
                        else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                            orderpri = 3;
                        }
                        else {
                            orderpri = 4;
                        }
                    }
                    else {
                        orderpri = 4;
                    }
                    this.allCaseList[i].ordercase = order;
                    this.allCaseList[i].orderpri = orderpri;
                }
                // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
                try {
                    /* this.allCaseList.sort(
                       (firstObject: any, secondObject: any) =>
                         (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                           (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                             (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                               (firstObject.orderpri == secondObject.orderpri ) ? (
                                 (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                                   (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                                         (firstObject.ordercase  > secondObject.ordercase ) ? 1 :
                                 -1 )
                                 :-1
                               -1 )
                               :-1
                           -1 )
                         : -1
                       );
           
                       */
                    this.allCaseList.sort(function (firstObject, secondObject) { return (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                        || firstObject.orderpri - secondObject.orderpri
                        || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                        || firstObject.ordercase - secondObject.ordercase); });
                }
                catch (_b) {
                }
                this.drawTableAllCase();
                return [2 /*return*/];
            });
        });
    };
    SharedCaseComponent.prototype.searchSharedCase = function (getAll) {
        if (getAll === void 0) { getAll = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filterd, tmpDate, para, fromDtShared, toDtShared, tmpDate, tmp, i, order, orderpri;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sharedHigh = this.sharedMedium = this.sharedLow = 0;
                        if (!this.role.dpa_list_sharecase) {
                            return [2 /*return*/];
                        }
                        //this.util.ShowWaiting(true)
                        $('#tbSharedCase').DataTable().clear().destroy();
                        filterd = [];
                        if (!getAll) return [3 /*break*/, 2];
                        tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)];
                    case 1:
                        filterd = _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        para = "";
                        fromDtShared = $('#dateFromShared').val();
                        toDtShared = $('#dateToShared').val();
                        if (this.caseNoShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoShared;
                        }
                        if (this.firstnameShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameShared;
                        }
                        if (this.lastnameShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameShared;
                        }
                        if (this.telephoneShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneShared;
                        }
                        if (this.caseTypeShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeShared;
                        }
                        if (this.caseSubTypeShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeShared;
                        }
                        if (this.subTypeDetailShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailShared;
                        }
                        if (this.statusShared.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusShared;
                        }
                        if (fromDtShared != null && fromDtShared != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        if (toDtShared != null && toDtShared != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        if (!(para.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", para)];
                    case 3:
                        filterd = _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)];
                    case 5:
                        filterd = _a.sent();
                        _a.label = 6;
                    case 6:
                        tmp = [];
                        filterd.forEach(function (c) {
                            if (c.dpa_caseowner == null && c.dpa_casestatuscode == "01") {
                                tmp.push(c);
                                if (c.dpa_caseseverityidname != null) {
                                    if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                        _this.sharedHigh++;
                                    }
                                    else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                        _this.sharedMedium++;
                                    }
                                    else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                        _this.sharedLow++;
                                    }
                                }
                            }
                        });
                        for (i = 0; i < tmp.length; i++) {
                            order = void 0;
                            orderpri = void 0;
                            if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress") {
                                order = 1;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold") {
                                order = 2;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new") {
                                order = 3;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved") {
                                order = 4;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel") {
                                order = 5;
                            }
                            else {
                                order = 6;
                            }
                            if (tmp[i].dpa_caseseverityidname != null) {
                                if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                    orderpri = 1;
                                }
                                else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                    orderpri = 2;
                                }
                                else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                    orderpri = 3;
                                }
                                else {
                                    orderpri = 4;
                                }
                            }
                            else {
                                orderpri = 4;
                            }
                            tmp[i].ordercase = order;
                            tmp[i].orderpri = orderpri;
                        }
                        // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
                        try {
                            /*
                                this.allCaseList.sort(
                                  (firstObject: any, secondObject: any) =>
                                    (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                                      (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(firstObject.dpa_slatime.substring(0, 10))) ? (
                                        (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                                          (firstObject.orderpri == secondObject.orderpri ) ? (
                                            (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                                              (new Date(firstObject.createdon.substring(0, 10))== new Date(firstObject.createdon.substring(0, 10))) ? (
                                                    (firstObject.ordercase  > secondObject.ordercase ) ? 1 :
                                            -1 )
                                            :-1
                                          -1 )
                                          :-1
                                      -1 )
                                    : -1
                                  );
                                  */
                            tmp.sort(function (firstObject, secondObject) { return (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                || firstObject.orderpri - secondObject.orderpri
                                || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                || firstObject.ordercase - secondObject.ordercase); });
                        }
                        catch (_b) {
                        }
                        this.sharedCaseList = tmp;
                        this.drawTableSharedCase();
                        return [2 /*return*/];
                }
            });
        });
    };
    SharedCaseComponent.prototype.searchAllCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para, fromDtAll, toDtAll, _a, tmpDate, _b, i, order, orderpri;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.allHigh = this.allMedium = this.allLow = 0;
                        if (!this.role.dpa_list_allcase) {
                            return [2 /*return*/];
                        }
                        //this.util.ShowWaiting(true)
                        $('#tbAllCase').DataTable().clear().destroy();
                        para = "";
                        fromDtAll = $('#dateFromAll').val();
                        toDtAll = $('#dateToAll').val();
                        if (this.caseNoAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoAll;
                        }
                        if (this.firstnameAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameAll;
                        }
                        if (this.lastnameAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameAll;
                        }
                        if (this.telephoneAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneAll;
                        }
                        if (this.caseTypeAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeAll;
                        }
                        if (this.caseSubTypeAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeAll;
                        }
                        if (this.subTypeDetailAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailAll;
                        }
                        if (this.statusAll.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusAll;
                        }
                        if (fromDtAll != null && fromDtAll != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtAll, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        if (toDtAll != null && toDtAll != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtAll, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        if (!(para.length > 0)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", para)];
                    case 1:
                        _a.allCaseList = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
                        _b = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)];
                    case 3:
                        _b.allCaseList = _c.sent();
                        _c.label = 4;
                    case 4:
                        this.allCaseList.forEach(function (c) {
                            if (c.dpa_caseseverityidname != null) {
                                if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                    _this.allHigh++;
                                }
                                else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                    _this.allMedium++;
                                }
                                else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                    _this.allLow++;
                                }
                            }
                        });
                        for (i = 0; i < this.allCaseList.length; i++) {
                            order = void 0;
                            orderpri = void 0;
                            if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress") {
                                order = 1;
                            }
                            else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold") {
                                order = 2;
                            }
                            else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new") {
                                order = 3;
                            }
                            else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved") {
                                order = 4;
                            }
                            else if (this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel") {
                                order = 5;
                            }
                            else {
                                order = 6;
                            }
                            if (this.allCaseList[i].dpa_caseseverityidname != null) {
                                if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                    orderpri = 1;
                                }
                                else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                    orderpri = 2;
                                }
                                else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                    orderpri = 3;
                                }
                                else {
                                    orderpri = 4;
                                }
                            }
                            else {
                                orderpri = 4;
                            }
                            this.allCaseList[i].ordercase = order;
                            this.allCaseList[i].orderpri = orderpri;
                        }
                        // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
                        try {
                            /* this.allCaseList.sort(
                               (firstObject: any, secondObject: any) =>
                                 (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                                   (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                                     (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                                       (firstObject.orderpri == secondObject.orderpri ) ? (
                                         (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                                           (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                                                 (firstObject.ordercase  > secondObject.ordercase ) ? 1 :
                                         -1 )
                                         :-1
                                       -1 )
                                       :-1
                                   -1 )
                                 : -1
                               );
                   
                               */
                            this.allCaseList.sort(function (firstObject, secondObject) { return (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                || firstObject.orderpri - secondObject.orderpri
                                || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                || firstObject.ordercase - secondObject.ordercase); });
                        }
                        catch (_d) {
                        }
                        this.drawTableAllCase();
                        return [2 /*return*/];
                }
            });
        });
    };
    SharedCaseComponent.prototype.resetSearchSharedCase = function () {
        this.caseNoShared = "";
        this.firstnameShared = "";
        this.lastnameShared = "";
        this.telephoneShared = "";
        this.caseTypeShared = "";
        this.caseSubTypeShared = "";
        this.subTypeDetailShared = "";
        this.statusShared = "";
        this.caseSubTypeSharedList = [];
        this.caseSubTypeDetailSharedList = [];
        $('#dateFromShared').val("").datepicker("update");
        $('#dateToShared').val("").datepicker("update");
    };
    SharedCaseComponent.prototype.resetSearchAllCase = function () {
        this.caseNoAll = "";
        this.firstnameAll = "";
        this.lastnameAll = "";
        this.telephoneAll = "";
        this.caseTypeAll = "";
        this.caseSubTypeAll = "";
        this.subTypeDetailAll = "";
        this.statusAll = "";
        this.caseSubTypeAllList = [];
        this.caseSubTypeDetailAllList = [];
        $('#dateFromAll').val("").datepicker("update");
        $('#dateToAll').val("").datepicker("update");
    };
    // ngAfterViewInit() {
    //   this.tbShared.changes.subscribe(t => {
    //     this.initTableShared()
    //   })
    //   this.tbAll.changes.subscribe(t => {
    //     this.initTableAll()
    //   })
    // }
    // ngForRendred() {
    //   console.log('NgFor is Rendered');
    //   if (this.dtAllCase == null) {
    //     this.initTableAll()
    //   }
    //   if (this.dtSharedCase == null) {
    //     this.initTableShared()
    //   }
    // }
    SharedCaseComponent.prototype.initTableShared = function () {
        var thisTs = this;
        $("#tbSharedCase tbody tr").on("click", function () {
            thisTs.caseID = $(this)[0].id;
            thisTs.caseTicket = $(this).find(".col-id")[0].innerText;
            $("#takeCaseModal").modal("show");
        });
        this.dtSharedCase = $("#tbSharedCase").dataTable({
            retrieve: true,
            'searching': false,
            order: [],
            "drawCallback": function (settings) {
                console.log('DataTables shared has redrawn the table');
            }
        });
    };
    SharedCaseComponent.prototype.initTableAll = function () {
        var thisTs = this;
        $("#tbAllCase tbody tr").on("click", function () {
            var ids = $(this).find(".col-id");
            var url = thisTs.util.baseUrl() + "/caseDetail/" + ids[0].innerText;
            window.open(url, '_blank');
        });
        this.dtAllCase = $("#tbAllCase").dataTable({
            retrieve: true,
            'searching': false,
            order: [],
            "drawCallback": function (settings) {
                console.log('DataTables all has redrawn the table');
            }
        });
    };
    SharedCaseComponent.prototype.takeCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        req = this.sharedCaseList.filter(function (c) {
                            return c.incidentid == _this.caseID;
                        });
                        req[0]["dpa_modifiedby"] = this.cookieData.userId;
                        req[0]["dpa_caseowner"] = this.cookieData.userId;
                        return [4 /*yield*/, this.apiService.put("crmservice", "caseIncident-takeOwner/" + this.caseID, req[0])];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.searchSharedCase(true)];
                    case 2:
                        _a.sent();
                        $("#takeCaseModal").modal("hide");
                        this.util.ShowWaiting(false);
                        this.util.SuccessDialog("รับเคสสำเร็จ");
                        setTimeout(function () {
                            var url = _this.util.baseUrl() + "/caseDetail/" + _this.caseTicket;
                            window.open(url, '_blank');
                        }, 800);
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog("รับเคสไม่สำเร็จ");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SharedCaseComponent.prototype.onCaseTypeAllChange = function () {
        var _this = this;
        if (this.caseTypeAll != null && this.caseTypeAll.length > 0) {
            this.caseSubTypeAllList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.caseTypeAll; });
        }
    };
    SharedCaseComponent.prototype.onCaseSubTypeAllChange = function () {
        var _this = this;
        if (this.caseSubTypeAll != null && this.caseSubTypeAll.length > 0) {
            this.caseSubTypeDetailAllList = this.subTypeDetailTmpList.filter(function (subType) { return subType.dpa_casesubtypeid === _this.caseSubTypeAll; });
        }
    };
    SharedCaseComponent.prototype.onCaseTypeSharedChange = function () {
        var _this = this;
        if (this.caseTypeShared != null && this.caseTypeShared.length > 0) {
            this.caseSubTypeSharedList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.caseTypeShared; });
        }
    };
    SharedCaseComponent.prototype.onCaseSubTypeSharedChange = function () {
        var _this = this;
        if (this.caseSubTypeShared != null && this.caseSubTypeShared.length > 0) {
            this.caseSubTypeDetailSharedList = this.subTypeDetailTmpList.filter(function (subType) { return subType.dpa_casesubtypeid === _this.caseSubTypeShared; });
        }
    };
    SharedCaseComponent.prototype.drawTableSharedCase = function () {
        var _this = this;
        $("#tbSharedCase tbody").empty();
        this.sharedCaseList.forEach(function (c) {
            var priority = "";
            var tr = "";
            if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center"></td>';
            }
            else {
                var severity = c.dpa_caseseverityidname.toLowerCase();
                if (severity == "high") {
                    priority = "3";
                }
                else if (severity == "medium") {
                    priority = "2";
                }
                else if (severity == "low") {
                    priority = "1";
                }
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center" data-sort="' + priority + '">' +
                    '<span class="dot ' + severity + '"></span>' +
                    '</td>';
            }
            tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
                '<td>' + c.dpa_casesubtypeidname + '</td>' +
                '<td>' + c.customeridname + '</td>' +
                '<td>' + c.dpa_casechannelidname + '</td>' +
                '<td>' + c.dpa_casestatusidname + '</td>' +
                '<td><span class="sr-only">' + _this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' +
                _this.util.transformDate(c.createdon, 'shortWithTime') + '</td>';
            if (c.dpa_issla) {
                tr += '<td align="center" class="high">Over</td>';
            }
            else {
                if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
                    tr += '<td align="center" class="low">Warning</td>';
                }
                else {
                    tr += '<td align="center" class="high"></td>';
                }
            }
            tr += '<td><span class="sr-only">' + _this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>'
                + _this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
                '</tr>';
            $("#tbSharedCase tbody").append(tr);
        });
        this.initTableShared();
    };
    SharedCaseComponent.prototype.drawTableAllCase = function () {
        var _this = this;
        $("#tbAllCase tbody").empty();
        this.allCaseList.forEach(function (c) {
            var priority = "";
            var tr = "";
            if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center"></td>';
            }
            else {
                var severity = c.dpa_caseseverityidname.toLowerCase();
                if (severity == "high") {
                    priority = "3";
                }
                else if (severity == "medium") {
                    priority = "2";
                }
                else if (severity == "low") {
                    priority = "1";
                }
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center" data-sort="' + priority + '">' +
                    '<span class="dot ' + severity + '"></span>' +
                    '</td>';
            }
            var statusName = "";
            if (c.dpa_casestatusidname) {
                statusName = c.dpa_casestatusidname;
            }
            tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
                '<td>' + c.dpa_casesubtypeidname + '</td>' +
                '<td>' + c.customeridname + '</td>' +
                '<td>' + c.dpa_casechannelidname + '</td>' +
                '<td>' + statusName + '</td>' +
                '<td><span class="sr-only">' + _this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' +
                _this.util.transformDate(c.createdon, 'shortWithTime') + '</td>';
            if (c.dpa_issla) {
                tr += '<td align="center" class="high">Over</td>';
            }
            else {
                if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
                    tr += '<td align="center" class="low">Warning</td>';
                }
                else {
                    tr += '<td align="center" class="high"></td>';
                }
            }
            tr += '<td><span class="sr-only">' + _this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>'
                + _this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
                '</tr>';
            $("#tbAllCase tbody").append(tr);
        });
        this.initTableAll();
    };
    return SharedCaseComponent;
}());
export { SharedCaseComponent };



// WEBPACK FOOTER //
// ./src/app/shared-case/shared-case.component.ts.pre-build-optimizer.js